// Asset configuration - Real app screenshots and uploaded images
// Local screenshots are served from /screenshots/ (public folder)

// Brand logos (uploaded assets)
export const LOGOS = {
  ariaOne: "/screenshots/ariaone-logo_white.png",
  ariaOneBlack: "/screenshots/ariaone-logo_black.png",
  lumina: "/screenshots/lumina_logo_white.png",
  luminaBlack: "/screenshots/lumina_logo_black.png",
  revq: "/screenshots/revq_logo_white.png",
  revqBlack: "/screenshots/revq_logo_black.png",
  echo: "/screenshots/echo_logo_white.png",
  echoBlack: "/screenshots/echo_logo_black.png",
};

// Emblems (uploaded assets)
export const EMBLEMS = {
  ariaOne: "/screenshots/ariaone-emblem_white.png",
  lumina: "/screenshots/lumina_emblem_white.png",
  revq: "/screenshots/revq_emblem_white.png",
  echo: "/screenshots/echo_emblem_white.png",
};

// App Screenshots - Real uploaded screenshots
// 01 = AriaOne dashboard, 02-10 = Lumina, 11-22 = RevQ, 23-29 = Echo
export const SCREENSHOTS = {
  // Main platform
  ariaDashboard: "/screenshots/screenshot-01.png",
  ariaHero: "/screenshots/screenshot-01.png",
  
  // Lumina (Clinical Intelligence) - screenshots 02-10
  luminaHero: "/screenshots/screenshot-02.png",
  luminaHighlight1: "/screenshots/screenshot-03.png",
  luminaHighlight2: "/screenshots/screenshot-04.png",
  luminaHighlight3: "/screenshots/screenshot-05.png",
  luminaHighlight4: "/screenshots/screenshot-06.png",
  luminaSticky1: "/screenshots/screenshot-07.png",
  luminaSticky2: "/screenshots/screenshot-08.png",
  luminaSticky3: "/screenshots/screenshot-09.png",
  luminaSticky4: "/screenshots/screenshot-10.png",
  luminaFullbleed: "/screenshots/screenshot-03.png",
  luminaEditorial1: "/screenshots/screenshot-04.png",
  luminaEditorial2: "/screenshots/screenshot-05.png",
  
  // RevQ (Billing Intelligence) - screenshots 11-22
  revqHero: "/screenshots/screenshot-11.png",
  revqHighlight1: "/screenshots/screenshot-12.png",
  revqHighlight2: "/screenshots/screenshot-13.png",
  revqHighlight3: "/screenshots/screenshot-14.png",
  revqHighlight4: "/screenshots/screenshot-15.png",
  revqSticky1: "/screenshots/screenshot-16.png",
  revqSticky2: "/screenshots/screenshot-17.png",
  revqSticky3: "/screenshots/screenshot-18.png",
  revqSticky4: "/screenshots/screenshot-19.png",
  revqFullbleed: "/screenshots/screenshot-20.png",
  revqEditorial1: "/screenshots/screenshot-21.png",
  revqEditorial2: "/screenshots/screenshot-22.png",
  
  // Echo (Scheduling Intelligence) - screenshots 23-29
  echoHero: "/screenshots/screenshot-23.png",
  echoHighlight1: "/screenshots/screenshot-24.png",
  echoHighlight2: "/screenshots/screenshot-25.png",
  echoHighlight3: "/screenshots/screenshot-26.png",
  echoHighlight4: "/screenshots/screenshot-27.png",
  echoSticky1: "/screenshots/screenshot-28.png",
  echoSticky2: "/screenshots/screenshot-29.png",
  echoSticky3: "/screenshots/screenshot-24.png",
  echoSticky4: "/screenshots/screenshot-25.png",
  echoFullbleed: "/screenshots/screenshot-26.png",
  echoEditorial1: "/screenshots/screenshot-27.png",
  echoEditorial2: "/screenshots/screenshot-28.png",
  
  // Product cards on homepage
  luminaCard: "/screenshots/screenshot-02.png",
  revqCard: "/screenshots/screenshot-11.png",
  echoCard: "/screenshots/screenshot-23.png",
};

// Integration logos
export const integrationLogos = [
  { name: 'Epic', abbr: 'Epic' },
  { name: 'Cerner', abbr: 'Cerner' },
  { name: 'athenahealth', abbr: 'athena' },
  { name: 'Allscripts', abbr: 'Allscripts' },
  { name: 'eClinicalWorks', abbr: 'eCW' },
  { name: 'NextGen', abbr: 'NextGen' },
  { name: 'Meditech', abbr: 'Meditech' },
  { name: 'DrChrono', abbr: 'DrChrono' },
];

// EHR logos for platform band
export const ehrLogos = [
  'Epic', 'Cerner', 'athenahealth', 'Allscripts', 'eClinicalWorks', 'NextGen'
];

export default { LOGOS, EMBLEMS, SCREENSHOTS, integrationLogos, ehrLogos };
